import React, { useEffect, useState } from 'react';
import { updateAccount } from 'app/api-ws/accounts-ws';
import {
  Alert,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Snackbar,
  TextField,
  Typography
} from '@mui/material';
import useAuth from 'app/hooks/useAuth';

function TableTreatmentEdit({ selectedItem, handleDialogClose, fetchAccountsById }) {
  // console.log('selecteddiqhi', selectedItem.paymentStatus);
  const {user} = useAuth();
  const [open, setOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarType, setSnackBarType] = useState('success');

  const [paymentMode, setPaymentMode] = useState(selectedItem?.paymentMode);
  const [balance, setBalance] = useState(selectedItem?.balance);
  const [paymentReceived, setPaymentReceived] = useState(selectedItem?.paymentReceived || 0);
  const [paymentStatus, setPaymentStatus] = useState(selectedItem?.paymentStatus);

  const disabledbutton = selectedItem?.balance === 0 ? true : false;

  function showSnackBar() {
    setOpen(true);
  }

  function handleClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }

  useEffect(() => {
    if (selectedItem?.price === null || paymentReceived === null) {
      setBalance(0);
    } else {
      const calculatedBalance = (selectedItem?.price - paymentReceived).toFixed(2);
      setBalance(calculatedBalance);
    }
  }, [paymentReceived]);

  const updateAccountSubmit = (event) => {
    const ps = balance == 0 ? 'Completed' : 'Pending';
    const updateAccountRequest = {
      _id: selectedItem._id,
      paymentMode: paymentMode,
      paymentReceived: paymentReceived,
      paymentStatus: ps,
      balance: balance
    };

    updateAccount(updateAccountRequest, user?.authToken)
      .then((res) => {
        // console.log(res);
        if (res.data.status === 'success') {
          // setSnackBarMessage('Accounts updated Successfully');
          // setSnackBarType('success');
          // showSnackBar();
          fetchAccountsById();
          handleDialogClose();
        } else {
          setSnackBarMessage('Error in updating Accounts');
          setSnackBarType('error');
          showSnackBar();
        }
      })
      .catch((err) => {
        console.log(err);
        setSnackBarMessage('Error in updating Accounts');
        setSnackBarType('error');
        showSnackBar();
      });
    // console.log('submitted');
  };
  return (
    <>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={snackBarType}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
      <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} rowSpacing={2}>
        <Grid item xs={12} justifyContent="space-between">
          <Typography xs={6} style={{ fontSize: '18px', fontWeight: 'bold' }}>
            {' '}
            Update Accounts for {selectedItem?.refTreatmentPlan}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="paymentMode">Payment Mode</InputLabel>
            <Select
              value={paymentMode || 'Cash'}
              onChange={(e) => {
                setPaymentMode(e.target.value);
              }}
              label="Payment Mode"
              input={<OutlinedInput label="Payment Mode" name="paymentMode" id="paymentMode" />}
            >
              <MenuItem value="Cash">Cash</MenuItem>
              <MenuItem value="UPI">UPI</MenuItem>
              <MenuItem value="Card">Card</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <TextField
            type="number"
            id="standard-basic"
            label="Payment  Received"
            variant="outlined"
            fullWidth
            disabled = {disabledbutton}
            value={paymentReceived}
            onChange={(event) => setPaymentReceived(event.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <InputLabel htmlFor="balance">Balance</InputLabel>
          <TextField
            type="number"
            id="standard-basic"
            variant="outlined"
            fullWidth
            value={balance}
            onChange={(event) => setBalance(event.target.value)}
            disabled
          />
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="paymentStatus">Payment Status</InputLabel>
            <Select
              disabled
              value={paymentStatus}
              onChange={(e) => {
                setPaymentStatus(e.target.value);
              }}
              label="Payment Status"
              input={
                <OutlinedInput label="Payment Status" name="paymentStatus" id="paymentStatus" />
              }
            >
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Completed">Completed</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={handleDialogClose} color="primary">
            <Typography color="#66b5a3">Cancel</Typography>
          </Button>
          <Button
            color="primary"
            variant="contained"
            type="submit"
            style={{ backgroundColor: '#66b5a3', color: 'white' }}
            onClick={updateAccountSubmit}
          >
            Update Accounts
          </Button>
        </Grid>

      </Grid>
    </>
  );
}

export default TableTreatmentEdit;
